/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ItemTypes from '../../constants/itemTypes';
import Attachments from '../Common/attachments';
import DescriptionField from '../Common/descriptionField';
import SelectField from '../Common/selectField';
import AcceptanceCriteria from '../Criteria/acceptanceCriteria';
import WorkerSelect from '../Common/workerSelect';
import OwnerSelect from '../Common/ownerSelect';
import { allows } from '../../utils/authorization';
import ProductSelect from '../Common/productSelect';
import { generateTeamOptions } from '../../utils/resultModalHelpers';

class DetailsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFull: false,
      isCriteriaFull: false
    };
  }

  toggleIsFull = () =>
    this.setState((prevState) => ({ isFull: !prevState.isFull }));

  toggleCriteriaFull = () =>
    this.setState((prevState) => ({
      isCriteriaFull: !prevState.isCriteriaFull
    }));

  render() {
    const {
      epic,
      attachmentList,
      criteria,
      addCriteria,
      removeCriteria,
      onSelectChange,
      teams,
      team,
      product
    } = this.props;
    const { isFull, isCriteriaFull } = this.state;

    const allowEdit = allows('update', epic);

    const { teamOptions, selectedTeam } = generateTeamOptions(
      product.teams || teams,
      team
    );

    return (
      <div className="details-tab">
        {!isCriteriaFull && (
          <div className={`row top-description ${isFull ? 'full' : ''}`}>
            <DescriptionField
              id={epic.id}
              type="WorkPackage"
              description={epic.description}
              onFieldChange={this.props.handleUpdate}
              allowEdit={allowEdit}
              isFull={isFull}
              toggleIsFull={this.toggleIsFull}
            />
            {!isFull && (
              <div className="selects-column detail-tab-right">
                <ProductSelect
                  allowEdit={allowEdit}
                  selectedTeam={selectedTeam}
                  onSelectChange={onSelectChange}
                  selectedProductId={epic.product_id}
                />
                <SelectField
                  label="Team"
                  value={selectedTeam}
                  options={teamOptions}
                  allowEdit={allowEdit && teamOptions.length > 0}
                  handleChange={onSelectChange}
                  clearable={!!epic.product_id}
                />
                <WorkerSelect
                  label="Owner"
                  selectedWorker={{ id: epic.owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={epic}
                />
                <OwnerSelect
                  label="Product Manager"
                  selectedOwner={{ id: epic.product_owner_id }}
                  allowEdit={allowEdit}
                  onUpdate={onSelectChange}
                  result={epic}
                />
              </div>
            )}
          </div>
        )}
        {!isFull && (
          <div className="row bottom-ac">
            <div className="ac-container">
              <AcceptanceCriteria
                addCriteria={addCriteria}
                removeCriteria={removeCriteria}
                criteria={criteria}
                workPackage={epic}
                isNew={!epic.id}
                isCriteriaFull={isCriteriaFull}
                toggleCriteriaFull={this.toggleCriteriaFull}
                detailCard
              />
            </div>
            {!isCriteriaFull && (
              <Attachments
                itemId={epic.id}
                type={ItemTypes.RESULT}
                allowCreate={allows('create_attachments', epic)}
                allowDelete={allows('destroy_attachments', epic)}
                attachmentList={attachmentList}
                addAttachment={this.props.addAttachment}
                removeAttachment={this.props.removeAttachment}
                isNew={!epic.id}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

DetailsTab.propTypes = {
  epic: PropTypes.object.isRequired,
  users: PropTypes.array,
  handleUpdate: PropTypes.func
};

export default DetailsTab;
